export const AnnotationType = {
    CLASS_PREPARATION: 'class_preparation',
    ACTIVITY: 'activity',
    INTERACTIVE_OBJECT: 'interactive_object',
    GUEST: 'guest',
};
